import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Spinner } from '@agconnections/grow-ui';
import ViewOnlyField from 'components/ViewOnlyField';
import useCropSeasonServiceApi from 'hooks/useCropSeasonServiceApi';
import {
  CROP_SEASON_FETCH_V2,
  CROP_SEASON_FETCH_V2_BY_ORG
} from 'constants/cropSeasonServiceV2Flags';

// Hoisted so the default keeps the stable identity defaultProps gave it.
const defaultCropSeasonIds = [];

const CropSeasonField = ({ cropSeasonIds = defaultCropSeasonIds }) => {
  const fetchApi = useCropSeasonServiceApi(
    'cropseason',
    CROP_SEASON_FETCH_V2,
    CROP_SEASON_FETCH_V2_BY_ORG
  );

  const [cropSeasonNames, setCropSeasonNames] = useState([]);
  const [loading, setLoading] = useState(cropSeasonIds.length > 0);

  useEffect(() => {
    if (!cropSeasonIds.length) {
      setCropSeasonNames([]);
      setLoading(false);
      return undefined;
    }

    setLoading(true);
    let isActive = true;
    const cancels = [];

    const requests = cropSeasonIds.map(cropSeasonId => {
      const { promise, cancel } = fetchApi.fetch(
        cropSeasonId,
        undefined,
        undefined,
        undefined,
        true // ignoreCache
      );
      cancels.push(cancel);
      return promise;
    });

    Promise.allSettled(requests).then(results => {
      if (!isActive) return;

      const fulfilledNames = results
        .filter(result => result.status === 'fulfilled')
        .map(fulfilledResult => fulfilledResult.value.data.name);

      setCropSeasonNames(fulfilledNames);
      setLoading(false);
    });

    return () => {
      isActive = false;
      cancels.forEach(cancel => cancel?.());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cropSeasonIds.join(','), fetchApi]);

  return (
    <div className="w-1/3">
      <ViewOnlyField header="Crop Seasons" className="w-1/3" text="text-lg" />
      {!loading ? (
        <span className="text-2xl w-1/3">
          {cropSeasonNames.join(', ') || '--'}
        </span>
      ) : (
        <Spinner />
      )}
    </div>
  );
};

CropSeasonField.propTypes = {
  cropSeasonIds: PropTypes.arrayOf(PropTypes.string)
};

export default CropSeasonField;
